import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { PrintActionButton } from '../../../components/sub-header/actions/PrintActionButton';
import { ShareActionButton } from '../../../components/sub-header/actions/ShareActionButton';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { detectUserAgent } from '../../../utils/userAgentUtils';
import styles from './law_firm_actions.module.scss';
import { useUser } from '../../../user/useUser';

type Props = {
  name: string;
  source: string;
};

export const LawFirmActions: FC<Props> = ({ name, source }) => {
  const { accessPremium } = useUser();
  const intl = useIntl();
  const textToCopy = () => {
    const profileUrl = `${window.location.origin}${window.location.pathname}`;
    return intl.formatMessage(
      { id: 'law-firm/page/LawFirmActions.tsx/1' },
      { name, profileUrl },
    );
  };

  const sendPrintAnalytics = () =>
    doctrineAnalytics('LawFirm ButtonPrintClicked');

  const sendShareAnalytics = () =>
    doctrineAnalytics('LawFirm ButtonCopyClicked');

  return (
    <>
      {detectUserAgent() !== 'Mozilla Firefox' && (
        <div className={styles.button}>
          <PrintActionButton
            accessPremium={accessPremium}
            sendAnalytics={sendPrintAnalytics}
            source={source}
          />
        </div>
      )}
      <div className={styles.button}>
        <ShareActionButton
          source={source}
          text={textToCopy()}
          sendAnalytics={sendShareAnalytics}
        />
      </div>
    </>
  );
};
